"use client";

import { POST_BY_SLUG_QUERYResult } from "@/sanity/types";
import { useTheme } from "@/contexts/ThemeContext";

type CommentsProps = {
  comments: NonNullable<POST_BY_SLUG_QUERYResult>["comments"];
};

const AllComments = ({ comments }: CommentsProps) => {
  const { themeColors } = useTheme();

  return (
    <div className="mt-0 md:mt-[60px]">
      <h2
        className={`text-medium md:text-large font-bold mb-2 ${themeColors.commentTitleColor}`}
      >
        COMMENTS
      </h2>
      <div className="pb-15 py-4 columns-1 md:columns-3 gap-[20px]">
        {comments.length === 0 && (
          <p className={themeColors.commentTextColor}>No comments yet</p>
        )}
        {comments.length > 0 &&
          comments.map((comment) => (
            <div
              style={{
                backgroundColor: themeColors.commentCardBackgroundColor,
              }}
              className={`flex flex-col items-start gap-2 rounded-[20px] mb-4 p-3 break-inside-avoid border ${themeColors.commentCardBorderColor}`}
              key={comment._createdAt}
            >
              <div className="flex items-center gap-2">
                <p className="text-[28px]">{comment.emoji}</p>
                <p className={`text-small ${themeColors.commentTextColor}`}>
                  {comment.comment}
                </p>
              </div>
              <div className="flex gap-2 justify-end w-full">
                <p className={`text-xsmall ${themeColors.commentDateColor}`}>
                  {new Date(comment._createdAt).toLocaleString()}
                </p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default AllComments;
